<template>
  <div class="system-builder__contact-dealer--section">

    <div class="system-builder__main-container">

      <div class="system-builder__contact-dealer--main-container">

        <div class="system-builder__contact-dealer--dealers-container">
          <div class="system-builder__main-container--header">
            <h2>Get a Quote from Your Local Dealer!</h2>
            <span @click="editContactForm">Edit Contact Info</span>
          </div>

          <div class="system-builder__contact-dealer--dealers-container-alt" v-if="sharedState.dealers === null">
            <spinner size="large" message="Loading dealers nearby..."></spinner>
          </div>

          <div class="system-builder__contact-dealer--dealer-items-container" v-else>
            <div v-for="(dealer, index) in sharedState.dealers"
                 class="system-builder__contact-dealer--dealer-item" :key="dealer.ID">
              <div class="system-builder__contact-dealer--dealer-content">
                <div class="dealer-details">
                  <h5>{{dealer.post_title}}</h5>
                  <p>
                    {{dealer.custom_fields.wpsl_address[0]}}<br>
                    {{dealer.custom_fields.wpsl_city[0]}}, {{dealer.custom_fields.wpsl_state[0]}} {{dealer.custom_fields.wpsl_zip[0]}}
                  </p>
                </div>

                <div class="pro-logo" v-if="dealer.custom_fields.tx_wpsl_store_category[0] === 'PRO'">
                  <img src="" alt="">
                </div>
              </div>
              <div class="system-builder__contact-dealer--dealer-cta-container">
                <div class="button__outline--primary"><a
                    :href="prepareTelLink(dealer.custom_fields.wpsl_phone[0])">Call</a>
                </div>
                <div class="button__solid--blue" v-if="dealer.custom_fields.wpsl_email[0]">Get E-Quote</div>
              </div>
            </div>
          </div>
        </div>

        <div class=" system-builder__contact-dealer--system-container">
          <div class="system-builder__main-container--content">
            <div class="system-builder__view-system--main-container">
              <div class="system-builder__view-system--system-container">
                <div class="system-builder__view-system--edit-nav">
                  <span>Your System</span>
                </div>

                <div class="system-builder__view-system--system-image" v-if="sharedState.selectedSystem">
                  <img :src="sharedState.selectedSystem.images[0].image.url"
                       :alt="sharedState.selectedSystem.images[0].image.alt">
                </div>

                <div class="system-builder__view-system--system-content">
                  <h4>{{sharedState.systemString}}</h4>
                  <ul>
                    <li>{{sharedState.selectedSystem.subtitle}}</li>
                  </ul>
                  <div v-html="sharedState.selectedSystem.description"></div>
                </div>
              </div>

              <div class="system-builder__view-system--addon-container">
                <div class="system-builder__view-system--remote-container">
                  <div class="system-builder__view-system--edit-nav">
                    <span>Your Remote</span>
                  </div>

                  <div class="system-builder__remotes--item">
                    <div class="system-builder__remotes--item-image">
                      <img :src="sharedState.selectedRemote.images[0].image.url"
                           :alt="sharedState.selectedRemote.images[0].image.alt">
                    </div>

                    <div class="system-builder__remotes--item-content">
                      <h3>{{sharedState.selectedRemote.post_title}}</h3>
                      <ul>
                        <li v-for="(feature, featureIndex) in sharedState.selectedRemote.remote_features"
                            v-if="featureIndex < 3">{{ feature }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div class="system-builder__view-system--upgrades-container">
                  <div class="system-builder__view-system--edit-nav">
                    <span>Your Upgrades</span>
                  </div>

                  <div class="system-builder__upgrades--item" v-for="upgrade in sharedState.selectedUpgrades">
                    <div class="system-builder__upgrades--item-image">
                      <img :src="upgrade.images[0].image.url" :alt="upgrade.images[0].image.alt">
                    </div>

                    <div class="system-builder__upgrades--item-content">
                      <h4>{{upgrade.post_title}}</h4>
                      <ul>
                        <li v-for="feature in upgrade.features" v-if="upgrade.features">{{feature}}</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>

    <footerNav></footerNav>
  </div>
</template>

<script>
  import store from '../../store'
  import footerNav from '../reusable/stickyFooterNavigation.vue'
  import spinner from 'vue-simple-spinner'
  import axios from 'axios'
  import $ from 'jquery'

  export default {
    components: {footerNav, spinner},
    name: 'contactDealer',
    data () {
      return {
        sharedState: store.state,
        mapHtml: '',
        mapData: '',
        altMap: ''
      }
    },
    methods: {
      retrieveDealers: function () {
        var ajaxUrl = 'https://' + window.location.hostname + '/wp-admin/admin-ajax.php'

        var googleMapUrl = 'https://maps.googleapis.com/maps/api/geocode/json?address=' + store.state.customerDetails.customerZip + '&key=AIzaSyBOPUa1-e4k7hsf5qVHNlBr-YHtN7UUQgo'
        var self = this
        axios.get(googleMapUrl)
          .then(function (response) {
            var latLon = response.data.results[0].geometry.location
            $.ajax({
              url: ajaxUrl,
              type: 'POST',
              data: {
                action: 'system-builder-get-dealers',
                location: latLon
              },
              cache: false,
              dataType: 'text',
              success: function (response) {
                var jsonObj = JSON.parse(response)
                self.mapData = jsonObj.mapData
                store.updateDealersState(jsonObj.stores)
                store.updateMapState(jsonObj.mapData)
                return false
              }
            })
          })
          .catch(function (error) {
            console.log(error)
          })
      },
      getMap: function () {
        var ajaxUrl = 'https://' + window.location.hostname + '/wp-admin/admin-ajax.php'

        var self = this

        $.ajax({
          url: ajaxUrl,
          type: 'POST',
          data: {
            action: 'get-map-with-dealers',
            dealerIds: '30275, 30101, 32647, 32921, 33634, 29909, 29908'
          },
          cache: false,
          dataType: 'text',
          success: function (response) {
            console.log(response)
            var jsonObj = JSON.parse(response)
            self.mapHtml = jsonObj
            return false
          }
        })
      },
      editContactForm: function () {
        store.changeFormValidationState(false)
      },
      prepareTelLink: function (val) {
        return 'tel:' + val
      },
      objectLength: function (object) {
        var length = 0
        for (var key in object) {
          if (object.hasOwnProperty(key)) {
            ++length
          }
        }
        return length
      }
    },
    mounted: function () {
      if (this.sharedState.dealers === null) {
        this.retrieveDealers()
      } else {
        store.getLocalStorage()
        store.setInquiryDataLocalStorage()
      }

      // Check if previous step has been completed before saving data
      if (store.state.customerDetails.customerZip !== '') {
        // Save inquiry data to database
        var ajaxUrl = 'https://' + window.location.hostname + '/wp-admin/admin-ajax.php'

        var inquiryDataSavedStatus = this.sharedState.inquiryDataSaved

        if (inquiryDataSavedStatus === false) {
          $.ajax({
            url: ajaxUrl,
            type: 'POST',
            dataType: 'text',
            data: {
              action: 'save-inquiry-data',
              data: store.getStoreDataToSave()
            },
            cache: false,
            success: function (response) {
              // var jsonObj = JSON.parse(response)
              store.inquiryDataSaved()
              return false
            }
          })
        }
      }

      this.getMap()
    }
  }
</script>



// WEBPACK FOOTER //
// ContactDealer.vue?5af14b91